export { default } from './FullScreenSection'



// WEBPACK FOOTER //
// ./src/components/FullScreenSection/index.ts